import React from 'react';
import { PropTypes } from 'prop-types';

import { Textarea } from '@ontruck/orc';
import AddressSuggestionsSelector from '../AddressSuggestionsSelector';
import ResponsiveModal from 'components/ResponsiveModal';
import { constants as addressesConstants } from 'utils/addresses';

const AddressLineField = ({
  className,
  responsiveModalRef,
  inputModalRef,
  inputRef,
  addressLine,
  handleChange,
  handleInputModalFocus,
  handleInputFocus,
  handleInputBlur,
  invalid,
  error,
  addresses,
  handleSuggestionSelected,
  t,
  names,
}) => (
  <ResponsiveModal
    className={className}
    modalRef={responsiveModalRef}
    inputRef={inputRef}
    refProperty="fieldRef"
    header={
      <Textarea
        id={names.address_line}
        name={names.address_line}
        fieldRef={inputModalRef}
        label={t('label_address_line')}
        onChange={handleChange}
        onFocus={handleInputModalFocus}
        size="L"
        fullWidth
        height="8rem"
        resize="vertical"
        invalid={invalid}
        error={error}
        value={addressLine}
      />
    }
    content={
      addresses.length > 0 ? (
        <AddressSuggestionsSelector
          options={addresses}
          onSuggestionClicked={handleSuggestionSelected}
          searchText={addressLine}
          suggestionType={addressesConstants.POI_ADDRESS_CONSTANTS.address_type}
        />
      ) : null
    }
  >
    <Textarea
      id={names.address_line}
      name={names.address_line}
      label={t('label_address_line')}
      onChange={handleChange}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
      size="L"
      fullWidth
      height="8rem"
      resize="vertical"
      invalid={invalid}
      error={error}
      value={addressLine}
    />
  </ResponsiveModal>
);

AddressLineField.propTypes = {
  responsiveModalRef: PropTypes.func,
  inputModalRef: PropTypes.func,
  inputRef: PropTypes.func,
  addressLine: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleInputModalFocus: PropTypes.func,
  handleInputFocus: PropTypes.func,
  handleInputBlur: PropTypes.func,
  invalid: PropTypes.bool,
  error: PropTypes.bool,
  handleSuggestionSelected: PropTypes.func,
  addresses: PropTypes.arrayOf(
    addressesConstants.PROP_TYPES.address_suggestion
  ),
  t: PropTypes.func.isRequired,
  names: addressesConstants.PROP_TYPES.address,
};

AddressLineField.defaultProps = {
  className: '',
  responsiveModalRef: () => {},
  inputModalRef: () => {},
  inputRef: () => {},
  addressLine: '',
  handleInputModalFocus: () => {},
  handleInputFocus: () => {},
  handleInputBlur: () => {},
  invalid: false,
  error: false,
  handleSuggestionSelected: () => {},
  addresses: [],
  names: {},
};

export default AddressLineField;
